import { createContext } from 'react';

type SidebarContextType = {
  onClose?: () => void;
};

const SidebarContext = createContext<SidebarContextType>({});

export const SidebarProvider = SidebarContext.Provider;
